import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Stack
} from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { AuthenticationType } from 'components/status-checks/authentication-form-utils'
import { ObservabilityToolAwsSecretsManagerAuthenticationOption } from 'components/status-checks/form/authentication/ObservabilityToolAwsSecretsManagerAuthenticationOption'
import { ObservabilityToolHeaders } from 'components/status-checks/form/authentication/ObservabilityToolHeaders'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

import type { StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'

export const ObservabilityToolAuthenticationTypeToggle = () => {
  const { control, trigger } = useFormContext<StatusCheckFormValues>()

  const [authenticationType, observabilityToolType] = useWatch({
    control,
    name: ['authenticationType', 'observabilityTool.type']
  })

  return (
    <FormControl>
      <Controller
        control={control}
        name="authenticationType"
        render={({ field }) => {
          return (
            <RadioGroup
              {...field}
              onChange={(e) => {
                const value = e.target.value as AuthenticationType
                field.onChange(value)

                trigger(['headers', 'secret'])
              }}
            >
              <FormControlLabel
                control={<Radio />}
                label="Use Authorization Header"
                value={AuthenticationType.AuthorizationHeader}
              />
              {authenticationType ===
                AuthenticationType.AuthorizationHeader && (
                <Stack sx={{ my: 2 }}>
                  <ObservabilityToolHeaders
                    isCustomObservabilityTool={
                      observabilityToolType === ObservabilityToolType.CUSTOM
                    }
                  />
                </Stack>
              )}
              <ObservabilityToolAwsSecretsManagerAuthenticationOption />
            </RadioGroup>
          )
        }}
      />
    </FormControl>
  )
}
